import {
  DatasetTableAction,
  DatasetTableConfig,
  deleteAction,
  editAction,
  formattedColumn,
  TableConfigBuilder,
  textColumn,
} from '@ui/lib/ui-kit/ui-dataset-table';
import { DeviceModel } from '@models/device.model';

function manageCamerasAction<T extends { model?: DeviceModel.SpeakerBrands }>(): DatasetTableAction<T> {
  return {
    id: 'manage-cameras',
    icon: 'ui-icon-add-camera',
    tooltip: 'SPEAKERS.MANAGE_CAMERAS',
    visible: (row) => row.model === DeviceModel.SpeakerBrands.SIP,
  };
}

function ipAddressFormatter(row: DeviceModel.LocationDeviceDocument): string {
  const parts = [row.ipAddress, row.sipUrl].filter(Boolean);
  return parts.length ? parts.join(' ') : '—';
}

export function createLocationSpeakersTableConfig(): DatasetTableConfig<DeviceModel.LocationDeviceDocument> {
  return new TableConfigBuilder<DeviceModel.LocationDeviceDocument>()
    .columns([
      textColumn<DeviceModel.LocationDeviceDocument>('name', 'SPEAKERS.NAME', {
        width: 'minmax(150px, 1fr)',
        mobileVisible: true,
        cardIcon: 'ui-icon-speaker',
      }),

      formattedColumn<DeviceModel.LocationDeviceDocument>(
        'model',
        'SPEAKERS.MODEL',
        (_, row) => row.model ?? 'N/A',
        {
          width: 'minmax(120px, 0.8fr)',
          mobileVisible: true,
          cardIcon: 'ui-icon-tag',
        },
      ),

      formattedColumn<DeviceModel.LocationDeviceDocument>(
        'ipAddress',
        'SPEAKERS.IP_ADDRESS_URL',
        (_, row) => ipAddressFormatter(row),
        {
          width: 'minmax(180px, 1fr)',
          mobileVisible: false,
          cardIcon: 'ui-icon-link',
        },
      ),
    ])
    .actions([
      manageCamerasAction(),
      editAction(),
      deleteAction(),
    ])
    .trackBy('_id')
    .rowHeight(52)
    .extend({
      responsive: {
        cardLayout: {
          cardFields: ['name', 'model', 'ipAddress'],
        },
      },
    })
    .build();
}
